export default __webpack_public_path__ + "0d30e46a2dfc5bbe273f3d88b3ba88f0.svg";